import React, { FC } from "react";
import { Card as MuiCard, CardContent } from "@mui/material";

interface CardProps {
  children: React.ReactNode;
  cusStyle: React.CSSProperties;
}

const GridCard: FC<CardProps> = ({ children, cusStyle }) => {
  return (
    <MuiCard sx={{ boxShadow: 3, borderRadius: 2, padding: "0px" }}>
      <CardContent
        sx={{
          padding: "0px",
          "&:last-child": {
            paddingBottom: "0px",
          },
        }}
        style={cusStyle}
      >
        {children}
      </CardContent>
    </MuiCard>
  );
};

export default GridCard;
